import React, { memo } from 'react';
import styled from 'styled-components';

import PinMilesIcon from 'assets/v2/PinMilesIcon';
import { COLORS } from 'theme';
import { TRIP_TYPE_NAMES } from 'utils/constants';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.ecruDark};
    background: ${COLORS.ecruLight};
    border-color: ${COLORS.ecru};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.ecruDark};
    }
  }
`;

function MileageReimbursementTripTypeTag(props) {
  return (
    <StyledTag
      label={TRIP_TYPE_NAMES.MILEAGE_REIMBURSEMENT}
      icon={<PinMilesIcon />}
      {...props}
    />
  );
}

export default memo(MileageReimbursementTripTypeTag);
